import React, { useContext, useEffect, useState } from "react";
import back from "../../assests/backButtonNew.svg";
import backButtonArrow from "../../assests/backButtonArrow.svg";
import user from "../../assests/user.svg";
import bellicon from "../../assests/bellicon.svg";
import shareButton from "../../assests/shareWithoutBg.svg";
import { useUserAuth } from "../../context/UserAuthContext";
import { useLocation, useNavigate, useParams } from "react-router";
import Context from "../../context/Context";
import axios from "axios";
import { createSearchParams } from "react-router-dom";
import SharePopup from "../SharePopup/SharePopup";
import ContestClosePopup from "../ContestClosePopup/ContestClosePopup";
import PwaBanner from "../PwaBanner/PwaBanner";
import { isEmpty } from "lodash";
import couponButton from "../../assests/couponButton.png";
export default function NavigationHeader({
  isFixed,
  type,
  handleParticipate,
  participateLoading,
  contestClosed,
  contestDetails,
  handleSignup,
  contestParticipationTimeOut,
  backFunction,
  handleSwitchBg,
  waterMarkSelected,
  handleChangeWaterMark,
}) {
  const {
    currentUser,
    setPreviousLocation,
    previousLocation,
    guestModeEnabled,
    searchParams,
  } = useUserAuth();
  const {
    campaignClosed,
    campaignEntryClosed,
    verifyUser,
    userIdToken,
    setUploadSucccess,
    preview,
    details,
    handleUserTracking,
    isPwa,
    isMobile,
    campaignMetaData,
    coupons,
    ads,
  } = useContext(Context);
  const location = useLocation();
  const navigateBack = details?.navigateBack;
  const { organizerName } = useParams();
  const campaignUniqueText = useParams().campaignUniqueText?.replace(
    /\.html$/,
    ""
  );
  const contestId = useParams().contestId?.replace(/\.html$/, "");
  const [contestClosedPopup, setContestClosedPopup] = useState(false);
  const [pwaBanner, setPwaBanner] = useState(true);
  const navigate = useNavigate();
  const token = userIdToken || currentUser?.accessToken;
  const [share, setShare] = useState(false);
  let isGoviral = false;
  if (campaignMetaData?.organizerName == "GV") {
    isGoviral = true;
  }
  const [newNotificationFound, setNewNotificationsFound] = useState(false);
  const campaignUniqueTextFromLocal =
    localStorage.getItem("campaignUniqueText");
  const prevUrl = searchParams?.get("prevUrl");

  const handleProfileNavigate = () => {
    setPreviousLocation(window.location.pathname);
    navigate(
      {
        pathname: `/profile`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      { state: { previousLocation: location?.pathname } }
    );
  };
  useEffect(() => {
    verifyUser();
    if (currentUser) {
      newNotificationCheck();
    }
  }, []);
  const handleNotificationNavigate = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate({
        pathname: `/${organizerName}/${campaignUniqueText}/notification`,
        search: "?preview=true",
      });
    } else {
      navigate({
        pathname: `/${organizerName}/${campaignUniqueText}/notification`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  const handleLogin = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate(
        {
          pathname: `/signup`,
          search: "?preview=true",
        },
        {
          state: {
            previousLocation: `/profile`,
          },
        }
      );
    } else {
      navigate(
        {
          pathname: `/signup`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        {
          state: {
            previousLocation: `/profile`,
          },
        }
      );
    }
  };
  const handleNavigate = () => {
    navigate({
      pathname: `/${organizerName}/${campaignUniqueText}`,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };
  const handleNavigateToPrevLocation = () => {
    if (previousLocation) {
      window.open(previousLocation, "_self");
    } else {
      navigate({
        pathname: `/${organizerName}/${campaignUniqueTextFromLocal}`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  const newNotificationCheck = () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_NOTIFICATION_STATUS_CHECKER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }).then((response) => {
      setNewNotificationsFound(response?.data?.data?.newNotificationFound);
    });
  };
  const handleNavigateToContest = () => {
    setUploadSucccess(false);

    navigate({
      pathname: `/${organizerName}/${campaignUniqueText}/${contestId}`,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };
  const participateButtonStyle = {
    backgroundColor: contestDetails?.participateBtnClr,
  };
  const particiapteButton = () => {
    if (isFixed) {
      if (contestParticipationTimeOut >= 0) {
        return (
          <div>
            {(campaignClosed || campaignEntryClosed || contestClosed) && (
              <>
                {/* <button
                  style={participateButtonStyle}
                  className="closedContest commonButton text-black"
                  onClick={() => setContestClosedPopup(true)}
                >
                  <span className="text-regular-bold">
                    {contestDetails?.buttonText}
                  </span>
                </button> */}
              </>
            )}
            {!campaignClosed &&
              !campaignEntryClosed &&
              !contestClosed &&
              (participateLoading ? (
                <div
                  style={participateButtonStyle}
                  className=" commonButton buttonInHeader text-black"
                >
                  <span className="text-regular-bold">Loading </span>
                </div>
              ) : guestModeEnabled ? (
                <div
                  style={participateButtonStyle}
                  className="commonButton buttonInHeader text-black"
                  id={`PB_${contestDetails?.contestId}`}
                  onClick={(e) => {
                    setPreviousLocation(window.location.pathname);
                    handleSignup(true);
                    handleUserTracking(e.currentTarget.id);
                  }}
                >
                  <span className="text-regular-bold ">
                    {contestDetails?.buttonText}
                  </span>
                </div>
              ) : (
                <div
                  style={participateButtonStyle}
                  className="commonButton buttonInHeader text-black"
                  id={`PB_${contestDetails?.contestId}`}
                  onClick={(e) => {
                    setPreviousLocation(window.location.pathname);
                    handleParticipate();
                    handleUserTracking(e.currentTarget.id);
                  }}
                >
                  <span className="text-regular-bold">
                    {contestDetails?.buttonText}
                  </span>
                </div>
              ))}
          </div>
        );
      } else {
        return (
          <>
            {/* <button
              style={participateButtonStyle}
              className="closedContest commonButton text-black"
              onClick={() => setContestClosedPopup(true)}
            >
              <span className="text-regular-bold">
                {contestDetails?.buttonText}
              </span>
            </button> */}
          </>
        );
      }
    }
  };
  const switchBgButton = () => {
    if (contestDetails?.waterMarkImage?.length > 1) {
      return (
        <button
          className="w-full px-[10px] py-[8px] bg-[#222] rounded-[8px] flex items-center justify-between gap-[8px] "
          onClick={handleSwitchBg}
        >
          <div className=" w-[32px] h-[32px] rounded-[4px] overflow-hidden shrink-0">
            <img
              src={waterMarkSelected?.fileUrl}
              className="aspect-square object-contain w-full h-full rounded-[4px] bg-white"
            />
          </div>

          <p className="text-small opacity-60 text_1Line">
            {waterMarkSelected?.name}
          </p>
          <p
            style={{ color: contestDetails?.buttonColor }}
            className="whitespace-nowrap text-small-bold"
          >
            {contestDetails?.pbButtonText || "Choose Photo Frame"}
          </p>
        </button>
      );
    }
  };

  const navigateToCoupons = () => {
    const targetDiv = document.getElementById("couponDiv");
    if (targetDiv) {
      targetDiv.scrollIntoView({
        behavior: "smooth", // Use smooth scrolling
        block: "start", // Align the top of the target element with the top of the visible area
      });
    }
  };

  const handleShare = () => {
    setShare((prev) => !prev);
  };

  const navigateToHome = () => {
    if (isMobile) {
      navigate(location?.state?.previousLocation || "/");
    } else {
      if (navigateBack) {
        window.location.href = navigateBack;
      } else {
        navigate(location?.state?.previousLocation || "/");
      }
    }
  };

  const navigateToPrev = () => {
    if (prevUrl == "omr") {
      window.location.href = "https://omrguide.com";
    } else if (location?.state?.previousLocation) {
      navigate({
        pathname: location?.state?.previousLocation,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    } else if (navigateBack) {
      window.location.href = navigateBack;
    } else {
      navigate({
        pathname: `/campaigns`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  const hideOffersAndCoupons = details?.hideOffersAndCoupons;

  return (
    <>
      {share && (
        <SharePopup
          showShare={handleShare}
          type="promoShare"
          url={details?.promoLink}
        />
      )}
      {contestClosedPopup && (
        <ContestClosePopup
          setPopup={setContestClosedPopup}
          backgroundColor={contestDetails?.buttonColor}
          message={`Sorry, this contest isn’t 
open to participation now`}
        />
      )}
      <div
        className={`w-[100%] sticky top-0  left-0 transition-all ease-in duration-500 z-[10] ${
          isFixed && (type == "contest" || type == "participate")
            ? "header-bg"
            : ""
        }`}
      >
        {type === "campaign" && (
          <div
            className={` w-[100%] py-[12px] px-[20px] flex items-center justify-between z-10`}
          >
            <diiv>
              {isMobile ? (
                <div
                  className="icon-bg relative  hover:cursor-pointer dismissButton z-[1] flex items-center justify-center"
                  onClick={navigateToHome}
                >
                  <img src={backButtonArrow} alt="" className="" />
                </div>
              ) : (
                (isGoviral ||
                  navigateBack ||
                  prevUrl ||
                  location?.state?.previousLocation) && (
                  <div
                    className="icon-bg relative  hover:cursor-pointer dismissButton z-[1] flex items-center justify-center"
                    onClick={navigateToPrev}
                  >
                    <img src={backButtonArrow} alt="" className="" />
                  </div>
                )
              )}
            </diiv>
            {hideOffersAndCoupons ||
              ((!isEmpty(coupons) || !isEmpty(ads)) && (
                <img
                  src={couponButton}
                  className="h-[44px] cursor-pointer animate-pulse"
                  onClick={navigateToCoupons}
                />
              ))}

            <div>
              {currentUser ? (
                <div className="flex gap-[13px]">
                  {!isPwa && (
                    <button
                      className="px-[16px] py-[12px] text-[#58B000] bg-[#FFFFFF] rounded-[12px] text-regular-medium"
                      onClick={() =>
                        navigate("/install", {
                          state: {
                            previousLocation: window.location.pathname,
                          },
                        })
                      }
                    >
                      Install Goviral App
                    </button>
                  )}
                  {details?.promoLink && (
                    <div
                      className="icon-bg relative flex items-center justify-center"
                      style={{ padding: "0" }}
                    >
                      <img
                        src={shareButton}
                        alt=""
                        className=" object-cover  overflow-hidden   cursor-pointer z-10"
                        onClick={handleShare}
                      />
                    </div>
                  )}
                  <div className="icon-bg relative">
                    <img
                      src={bellicon}
                      alt=""
                      className=" object-cover  overflow-hidden   cursor-pointer z-10"
                      onClick={handleNotificationNavigate}
                    />
                    {newNotificationFound && (
                      <div className="new-notification-indication absolute top-[2px] right-[2px]" />
                    )}
                  </div>
                  <img
                    src={currentUser?.photoURL ? currentUser?.photoURL : user}
                    alt=""
                    className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                    onClick={handleProfileNavigate}
                  />
                </div>
              ) : (
                <div className="flex gap-[16px]">
                  {!isPwa && (
                    <button
                      className="px-[16px] py-[12px] text-[#58B000] bg-[#FFFFFF] rounded-[12px] text-regular-medium"
                      onClick={() =>
                        navigate("/install", {
                          state: {
                            previousLocation: window.location.pathname,
                          },
                        })
                      }
                    >
                      Install Goviral App
                    </button>
                  )}
                  {details?.promoLink && (
                    <div
                      className="icon-bg relative flex items-center justify-center"
                      style={{ padding: "0" }}
                    >
                      <img
                        src={shareButton}
                        alt=""
                        className=" object-cover  overflow-hidden   cursor-pointer z-10"
                        onClick={handleShare}
                      />
                    </div>
                  )}

                  <img
                    src={user}
                    alt=""
                    className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                    onClick={handleLogin}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {type === "contest" && (
          <div className=" flex items-center justify-between w-[100%] py-[12px] px-[20px] relative">
            {pwaBanner && isFixed && !isPwa && (
              <div className="absolute w-full left-0 bottom-[-100%] ">
                <PwaBanner setBanner={setPwaBanner} />
              </div>
            )}

            {details.contests && details.contests.length > 1 ? (
              <div
                className="icon-bg relative  hover:cursor-pointer dismissButton z-[1] flex items-center justify-center"
                onClick={handleNavigate}
              >
                <img src={backButtonArrow} alt="" className="" />
              </div>
            ) : (
              <div>
                {isMobile ? (
                  <div
                    className="icon-bg relative  hover:cursor-pointer dismissButton z-[1] flex items-center justify-center"
                    onClick={navigateToHome}
                  >
                    <img src={backButtonArrow} alt="" className="" />
                  </div>
                ) : (
                  (isGoviral ||
                    navigateBack ||
                    prevUrl ||
                    location?.state?.previousLocation) && (
                    <div
                      className="icon-bg relative  hover:cursor-pointer dismissButton z-[1] flex items-center justify-center"
                      onClick={navigateToPrev}
                    >
                      <img src={backButtonArrow} alt="" className="" />
                    </div>
                  )
                )}
              </div>
            )}
            {isFixed ? (
              particiapteButton()
            ) : (
              <>
                {!isPwa && (
                  <button
                    className="px-[16px] py-[12px] text-[#58B000] bg-[#FFFFFF] rounded-[12px] text-regular-medium"
                    onClick={() =>
                      navigate("/install", {
                        state: { previousLocation: window.location.pathname },
                      })
                    }
                  >
                    Install Goviral App
                  </button>
                )}
                {hideOffersAndCoupons ||
                  ((!isEmpty(coupons) || !isEmpty(ads)) && (
                    <img
                      src={couponButton}
                      className="h-[44px] cursor-pointer animate-pulse"
                      onClick={navigateToCoupons}
                    />
                  ))}
              </>
            )}
            <div className="flex gap-[16px]">
              {currentUser ? (
                <>
                  {!details?.closedCampaign && (
                    <div className="icon-bg relative">
                      <img
                        src={bellicon}
                        alt=""
                        className=" object-cover  overflow-hidden   cursor-pointer z-10"
                        onClick={handleNotificationNavigate}
                      />
                      {newNotificationFound && (
                        <div className="new-notification-indication absolute top-[2px] right-[2px]" />
                      )}
                    </div>
                  )}
                  <img
                    src={currentUser?.photoURL ? currentUser?.photoURL : user}
                    alt=""
                    className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                    onClick={handleProfileNavigate}
                  />
                </>
              ) : (
                <img
                  src={user}
                  alt=""
                  className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                  onClick={() => handleSignup()}
                />
              )}
            </div>
          </div>
        )}
        {type === "participate" && (
          <div className=" flex items-center justify-between w-[100%] py-[12px] px-[20px]">
            <img
              src={back}
              alt=""
              className="w-[40px] h-[40px] hover:cursor-pointer dismissButton z-[1]"
              onClick={handleNavigateToContest}
            />
          </div>
        )}
        {type === "signup" && (
          <div className=" flex items-center justify-between w-[100%] py-[12px] px-[20px]">
            <img
              src={back}
              alt=""
              className="w-[40px] h-[40px] hover:cursor-pointer dismissButton z-[1]"
              onClick={handleNavigateToPrevLocation}
            />
          </div>
        )}
        {type === "mask" && (
          <div className=" flex items-center justify-between w-[100%] py-[12px] px-[20px] gap-[10px] w-full">
            <img
              src={back}
              alt=""
              className="w-[40px] h-[40px] hover:cursor-pointer dismissButton z-[1]"
              onClick={backFunction}
            />
            {contestDetails?.waterMarkImage?.length > 1 && (
              <div className="flex items-center gap-[8px] w-full flex-grow min-w-0">
                <div
                  className="rounded-[5px] shrink-0 cursor-pointer h-[52px] w-[52px] bg-white flex items-center justify-center"
                  onClick={handleSwitchBg}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.3501 13.3562C13.2568 13.4482 13.1311 13.4998 13.0001 13.5C12.8673 13.4994 12.7398 13.448 12.6438 13.3562L9.94385 10.65C8.80671 11.6051 7.34474 12.0844 5.86285 11.9878C4.38095 11.8912 2.99355 11.2263 1.99 10.1316C0.986453 9.037 0.444243 7.5972 0.476455 6.1125C0.508667 4.62782 1.11282 3.21288 2.1629 2.1628C3.21298 1.11272 4.62791 0.508568 6.1126 0.476356C7.59729 0.444143 9.0371 0.986354 10.1317 1.9899C11.2264 2.99345 11.8913 4.38085 11.9879 5.86275C12.0845 7.34465 11.6052 8.80661 10.6501 9.94375L13.3501 12.6437C13.3973 12.6903 13.4349 12.7457 13.4605 12.8069C13.4861 12.8681 13.4993 12.9337 13.4993 13C13.4993 13.0663 13.4861 13.1319 13.4605 13.1931C13.4349 13.2543 13.3973 13.3097 13.3501 13.3562ZM6.2501 11C7.18956 11 8.10792 10.7214 8.88906 10.1995C9.67019 9.67754 10.279 8.93569 10.6385 8.06774C10.998 7.1998 11.0921 6.24473 10.9088 5.32332C10.7255 4.40191 10.2732 3.55554 9.60885 2.89124C8.94455 2.22694 8.09819 1.77455 7.17678 1.59127C6.25537 1.40799 5.3003 1.50205 4.43235 1.86157C3.5644 2.22109 2.82255 2.82991 2.30062 3.61104C1.77868 4.39217 1.5001 5.31054 1.5001 6.25C1.50175 7.50927 2.00273 8.71649 2.89317 9.60693C3.78361 10.4974 4.99083 10.9983 6.2501 11Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="flex items-center gap-[8px] overflow-auto no-scrollbar">
                  {contestDetails?.waterMarkImage?.map((option, index) => (
                    <div
                      key={index}
                      className="rounded-[5px] shrink-0 cursor-pointer h-[52px] w-[52px] bg-white"
                      style={{
                        border:
                          option?._id == waterMarkSelected?._id
                            ? "3px solid #cc9999"
                            : "none",
                      }}
                      onClick={() => {
                        handleChangeWaterMark(option);
                      }}
                    >
                      <img
                        src={option?.fileUrl}
                        className="aspect-square object-contain w-full rounded-[5px] shrink-0 bg-white"
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* {switchBgButton()} */}
            {/* <div className="w-[40px]" /> */}
          </div>
        )}
      </div>
    </>
  );
}
